import { SaveIndicator } from '@st/theme'
import { documentUploadsModule, selHasActiveUploads } from '~/features/document-uploads'
import {
  selFolderSaveStatus,
  selFolder
} from '~/features/st-folder-viewer/st-folder-selectors'
import { useSelect } from '~/store'
import { useState } from 'react'

type Props = {
  className?: string
}

export function ClientOrganizerSaveIndicator({ className }: Props) {
  const [mountedAt] = useState(() => new Date())
  const folder = useSelect('stFolder', selFolder)
  const saveStatus = useSelect('stFolder', selFolderSaveStatus)
  const hasActiveUploads = useSelect('documentUploads', (s) => {
    if (!folder) return false
    return selHasActiveUploads(s, folder.id)
  })

  const normalizedSaveStatus = normalizeSaveStatus(saveStatus, hasActiveUploads)

  if (!folder) {
    return null
  }

  return (
    <SaveIndicator
      className={className}
      saveStatus={normalizedSaveStatus}
      initialLastSavedAt={mountedAt}
    />
  )
}

function normalizeSaveStatus(saveStatus: 'saving' | 'saved', hasActiveUploads: boolean) {
  if (saveStatus == 'saving') return 'saving'
  if (hasActiveUploads) return 'saving'
  return 'saved'
}
